export const kojiLines = {
  train: {
    lines: [
      { speaker: "Koji", text: "Each dawn I shave clean—\nThe past rinses with the blade.\nRegret grows no hair." },
      { speaker: "Randy", text: "I tried to shave once—\nbut I cried when I nicked me.\nMy soul grew that hair." },

      { speaker: "Koji", text: "Trains come, trains depart—\nBut my dog waits by the gate.\nHe trusts I’ll return." },
      { speaker: "Randy", text: "My dog left me twice.\nFirst for snacks, then for freedom.\nStill a good, good boy." },

      { speaker: "Koji", text: "Rain on iron tracks—\nSilence louder than shouting.\nPeace hums in the steam." },
      { speaker: "Randy", text: "Steam fogged up my shades.\nI walked into a noodle.\nPeace tasted like pork." },

      { speaker: "Koji", text: "She said I loved stone—\ncold, unmoving, unshifting.\nNow moss warms my path." },
      { speaker: "Randy", text: "I once loved a rock.\nNamed her Sandy. She left me.\nRolled off with some moss." },

      { speaker: "Koji", text: "This broom is my bell.\nSweeping dust like chanting prayer—\nEven trash has grace." },
      { speaker: "Randy", text: "Once swept for a crush.\nTurns out it was her dog shed.\nStill counts as romance." },

      { speaker: "Koji", text: "Offer no loud truth—\nA whisper can guide a train\nwhen the wind leans in." },
      { speaker: "Randy", text: "I whispered once too.\nTo a vending machine ghost.\nShe gave me warm tea." }
    ],
    voices: [
      "koji_train1",
      "koji_train2",
      "koji_train3",
      "koji_train4",
      "koji_train5",
      "koji_train6"
    ],
    randyVoices: [
      "randy_koji1",
      "randy_koji2",
      "randy_koji3",
      "randy_koji4",
      "randy_koji5",
      "randy_koji6"
    ]
  }
};

export default kojiLines;
